import request from '@/config';

enum Apis {
	CreateNation = `/api/nations/insertnation`,
	EditNation = `/api/nations/editnationbyid`,
	GetNationList = `/api/nations/getpagedlist`,
	GetNation = `/api/nations/getdetailbyid`,
	DeleteNation = `/api/nations/deletenationbyid`,
	NationImport = `/api/nations/nationimport`,
	CurrencyImport = `/api/nations/currencyimport`,
	NationSelect = `/api/nations/getnationselect`,
	CurrencyList = `/api/nations/getcurrencylistbycache`,
}

export const GetCurrencyDpListApi = (): Promise<IResponse> => request.post({ url: Apis.CurrencyList, data: {} });

export const GetNationSelectApi = (): Promise<IResponse> => request.post({ url: Apis.NationSelect, data: {} });

export const NationCreateApi = (input: any): Promise<IResponse> => request.post({ url: Apis.CreateNation, data: input });

export const NationEditApi = (input: any): Promise<IResponse> => request.post({ url: Apis.EditNation, data: input });

export const GetNationListApi = (search: any): Promise<IResponse> => request.post({ url: Apis.GetNationList, data: search });

export const GetNationInfoApi = (rowId: any): Promise<IResponse> => request.post({ url: Apis.GetNation, data: { id: rowId } });

export const DeleteNationApi = (input: any): Promise<IResponse> => request.post({ url: Apis.DeleteNation, data: input });

/* 导入货币数据 */
export const CurrencyImportApi = (importList: any[]): Promise<IResponse> => request.post({ url: Apis.CurrencyImport, data: importList });

/* 导入国家数据 */
export const NationImportApi = (importList: any[]): Promise<IResponse> => request.post({ url: Apis.NationImport, data: importList });
